import { RequestService } from '../../../../../common/services/RequestService';
import { formFilterRequestStr } from '../../../../../common/utils/format';
import { FILTER_REQUESTS } from '../constants';

export const filterRequestsRequest = payload => {
  return RequestService.get(
    `${FILTER_REQUESTS}?${formFilterRequestStr(payload)}`
  );
};
